module.exports = __webpack_public_path__ + "media/images/application/template/icon-cards-e8d0041d66359507792f2da05f20b630.png";